// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_header__mnjkC {
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.styles_title__1Y4wB {
  align-items: center;
  color: #18316e;
  display: flex;
  font-family: "Abhaya Libre";
  font-size: 2rem;
  font-weight: 600;
  flex: 1 1;
}

.styles_accordion_table__YWAM8 {
  width: 100%;
}

.styles_accordion_table__YWAM8 th {
  background-color: #f5f5f5;
  border-radius: 6px;
  color: #18316e;
  padding: 0.5rem 1rem;
  position: relative;
  box-sizing: border-box;
}

.styles_accordion_table__YWAM8 th,
.styles_accordion_table__YWAM8 td {
  border-bottom: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.styles_button_action_container__3CwjJ {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.styles_aviso_vazio__wQ-Fg {
  color: #18316e;
}

.styles_deleteBtn__IHP9i {
  all: unset;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.5s ease-in-out;
  width: 2.5rem;
  height: 2.5rem;
  justify-content: center;
  align-items: center;
}

.styles_deleteBtn__IHP9i:hover {
  background-color: #ddd;
}

.styles_alertModal__2Cy5Q {
  font-size: 1.2rem;
  color: #18316e;
  font-weight: 500;
}

.styles_grid_container__IwhU8 {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  width: 100% !important;
}

.styles_card_container__5lfcW {
  border-radius: 10px;
  box-shadow: 2px 2px 5px #cecece;
  /* padding: 2.5rem 1rem 3rem 1rem; */
  position: relative;
  width: 27rem;
  /* width: 48%; */
}

.styles_card_container__5lfcW strong {
  margin-right: 0.5rem;
}

.styles_card_header__K9UX\\+ {
  background: #18316e;
  border-radius: 10px 10px 0 0;
  box-shadow: 2px 0 5px #cecece;
  color: white;
  left: 0;
  padding: 0.3rem 1rem;
  position: block;
  top: 0;
  width: 100%;
}

.styles_card_content__6BaDI {
  max-height: 13rem;
  overflow-y: auto;
  padding: 0.7rem;
}

.styles_card_text__ragkZ {
  display: flex;
  overflow-y: auto;
}

.styles_card_buttons__-tdvc {
  border-radius: 0 0px 10px 10px;
  border-top: 1px solid #18316e;
  bottom: 0;
  display: flex;
  left: 0;
  position: inline;
  width: 100%;
}

.styles_card_buttons__-tdvc button {
  align-items: center;
  background: none;
  border: none;
  color: #18316e;
  display: flex;
  justify-content: center;
  padding: 0.5rem;
  text-align: center;
  width: 100%;
}

.styles_card_buttons__-tdvc button:hover {
  background: #ececec;
  cursor: pointer;
}

.styles_card_buttons__-tdvc span {
  margin-right: 0.5rem;
}

@media screen and (max-width: 769px) {
  .styles_container__9U5dP {
    justify-content: space-around;
  }
  .styles_card_container__5lfcW {
    width: 100%;
  }

}
`, "",{"version":3,"sources":["webpack://./src/pages/ExtratorRelatorios/FiltroSalvos/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;EACZ,OAAO;EACP,oBAAoB;EACpB,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,SAAS;EACT,aAAa;EACb,OAAO;EACP,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,WAAW;EACb;;AAEF","sourcesContent":[".header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.title {\n  align-items: center;\n  color: #18316e;\n  display: flex;\n  font-family: \"Abhaya Libre\";\n  font-size: 2rem;\n  font-weight: 600;\n  flex: 1;\n}\n\n.accordion_table {\n  width: 100%;\n}\n\n.accordion_table th {\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  color: #18316e;\n  padding: 0.5rem 1rem;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.accordion_table th,\n.accordion_table td {\n  border-bottom: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.button_action_container {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.aviso_vazio {\n  color: #18316e;\n}\n\n.deleteBtn {\n  all: unset;\n  box-sizing: border-box;\n  display: flex;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: all 0.5s ease-in-out;\n  width: 2.5rem;\n  height: 2.5rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.deleteBtn:hover {\n  background-color: #ddd;\n}\n\n.alertModal {\n  font-size: 1.2rem;\n  color: #18316e;\n  font-weight: 500;\n}\n\n.grid_container {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 100% !important;\n}\n\n.card_container {\n  border-radius: 10px;\n  box-shadow: 2px 2px 5px #cecece;\n  /* padding: 2.5rem 1rem 3rem 1rem; */\n  position: relative;\n  width: 27rem;\n  /* width: 48%; */\n}\n\n.card_container strong {\n  margin-right: 0.5rem;\n}\n\n.card_header {\n  background: #18316e;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 2px 0 5px #cecece;\n  color: white;\n  left: 0;\n  padding: 0.3rem 1rem;\n  position: block;\n  top: 0;\n  width: 100%;\n}\n\n.card_content {\n  max-height: 13rem;\n  overflow-y: auto;\n  padding: 0.7rem;\n}\n\n.card_text {\n  display: flex;\n  overflow-y: auto;\n}\n\n.card_buttons {\n  border-radius: 0 0px 10px 10px;\n  border-top: 1px solid #18316e;\n  bottom: 0;\n  display: flex;\n  left: 0;\n  position: inline;\n  width: 100%;\n}\n\n.card_buttons button {\n  align-items: center;\n  background: none;\n  border: none;\n  color: #18316e;\n  display: flex;\n  justify-content: center;\n  padding: 0.5rem;\n  text-align: center;\n  width: 100%;\n}\n\n.card_buttons button:hover {\n  background: #ececec;\n  cursor: pointer;\n}\n\n.card_buttons span {\n  margin-right: 0.5rem;\n}\n\n@media screen and (max-width: 769px) {\n  .container {\n    justify-content: space-around;\n  }\n  .card_container {\n    width: 100%;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `styles_header__mnjkC`,
	"title": `styles_title__1Y4wB`,
	"accordion_table": `styles_accordion_table__YWAM8`,
	"button_action_container": `styles_button_action_container__3CwjJ`,
	"aviso_vazio": `styles_aviso_vazio__wQ-Fg`,
	"deleteBtn": `styles_deleteBtn__IHP9i`,
	"alertModal": `styles_alertModal__2Cy5Q`,
	"grid_container": `styles_grid_container__IwhU8`,
	"card_container": `styles_card_container__5lfcW`,
	"card_header": `styles_card_header__K9UX+`,
	"card_content": `styles_card_content__6BaDI`,
	"card_text": `styles_card_text__ragkZ`,
	"card_buttons": `styles_card_buttons__-tdvc`,
	"container": `styles_container__9U5dP`
};
export default ___CSS_LOADER_EXPORT___;
